import 'rc-select/assets/index.css';

import React from 'react';
import classnames from 'classnames';
import Select, { Option } from 'rc-select';
import './style.css';

const TeacherSelect = ({
  name, options, value, placeholder, onChange, extendText, size
}) => (
  <div
    className={classnames('teacher-select', {
      [`teacher-select--${size}`]: size
    })}
  >
    <Select
      value={value}
      style={{ width: '100%' }}
      animation="slide-up"
      placeholder={<p>{placeholder}</p>}
      showSearch={false}
      onChange={valueI => onChange(name, valueI)}
      optionLabelProp="children"
      optionFilterProp="text"
    >
      {options.map((option, index) => {
        const text =
          typeof option === 'string' ? option : option.extendable ?
            `${option.description} ${extendText}` :
            option.description;
        const myValue = typeof option === 'string' ? option : option.id;
        return (
          <Option key={index} value={myValue} text={text}>
            {text}
          </Option>
        );
      })}
    </Select>
  </div>
);

export default TeacherSelect;



// WEBPACK FOOTER //
// ./src/components/TeacherSelect/index.js